import { layoutTags } from '@dc-platform/dc-interaction'
export const goBack = function () {
  if (location.hostname === 'localhost') {
    window.history.back()
  } else {
    layoutTags.close()
  }
}
